/** Callback for navigation (e.g. so a parent app's router can be used). */
export type ExternalLink = () => void;

export class Header {
    constructor(
        /** In large text, identifies the page to the user. Translatable. */
        public pageTitle: string = null,
        /** Tooltip content for the page. Translatable. */
        public pageTooltip: string = null,
        /** Identifies page in launch help request. */
        public ultiProHelpPageName: string = null,
        /** Breadcrumb (route.path) of THIS page. Translatable. */
        public breadcrumb: string = null,
        /** Breadcrumbs of preceeding pages. */
        public readonly breadcrumbs: string[] = null,
        /** Derived from breadcrumbs and router. Title is breadcrumb of matched route. Link is its path. */
        public breadcrumbTrail: Array<{ pageTitle: string; link: string | ExternalLink }> = null,
        /** An override for the back button link, which would otherwise be breadcrumbTrail pop. */
        public customBackLink: string | ExternalLink = null,
    ) { }
}
